import React, { useState } from 'react';
import { TrashIcon } from '@heroicons/react/24/outline';

const PersonalTab = ({ register, errors, watch, setValue, clearErrors, setError, inputClassName, genders }) => {
  const [image, setImage] = useState('');
  
  const handleProfilePictureChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setValue('image', file);
        setImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };
  
  const handleDeleteImage = () => {
    setValue('image', '');
    setValue('remove_image', true);
    setImage('');
  };
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
        {/* First Name */}
        <div>
          <label htmlFor="firstName" className="block text-sm font-medium text-gray-700">
            First Name <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            id="firstName"
            {...register('first_name')}
            className={`${inputClassName} ${errors.first_name ? 'border-red-500' : ''}`}
            placeholder="Enter First Name"
          />
          {errors.first_name && (
            <p className="mt-1 text-sm text-red-600">{errors.first_name.message}</p>
          )}
        </div>

        {/* Last Name */}
        <div>
          <label htmlFor="lastName" className="block text-sm font-medium text-gray-700">
            Last Name <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            id="lastName"
            {...register('last_name')}
            className={`${inputClassName} ${errors.last_name ? 'border-red-500' : ''}`}
            placeholder="Enter Last Name"
          />
          {errors.last_name && (
            <p className="mt-1 text-sm text-red-600">{errors.last_name.message}</p>
          )}
        </div>

        {/* Gender */}
        <div>
          <label htmlFor="gender" className="block text-sm font-medium text-gray-700">
            Gender <span className="text-red-500">*</span>
          </label>
          <select
            id="gender"
            {...register('gender')}
            className={`${inputClassName} ${errors.gender ? 'border-red-500' : ''}`}
          >
            <option value="">Select Gender</option>
            {genders?.map((gender) => (
              <option key={gender.id} value={gender.id}>{gender.name}</option>
            ))}
          </select>
          {errors.gender && (
            <p className="mt-1 text-sm text-red-600">{errors.gender.message}</p>
          )}
        </div>

        {/* Date of Birth */}
        <div>
          <label className="block text-sm font-medium text-gray-700">Date of Birth</label>
          <input
            type="text"
            {...register('dob')}
            onInput={(e) => {
              setValue('dob', e.target.value);
              
            }}
            className={`${inputClassName} datepicker`}
            placeholder="Enter Date of Birth"
          />
        </div>

        {/* SSN */}
        <div>
          <label className="block text-sm font-medium text-gray-700">SSN</label>
          <input
            type="text"
            {...register('ssn')}
            className={inputClassName}
            placeholder="Enter SSN"
          />
        </div>

        {/* Driver's License */}
        <div>
          <label className="block text-sm font-medium text-gray-700">Driver's License Number</label>
          <input
            type="text"
            {...register('driver_license_number')}
            className={inputClassName}
            placeholder="Enter Driver's License Number"
          />
        </div>

        {/* Driver's License Expiration */}
        <div>
          <label className="block text-sm font-medium text-gray-700">Driver's License Expiration Date</label>
          <input
            type="text"
            {...register('driver_license_expiry_date')}
            className={`${inputClassName} datepicker`}
            onInput={(e) => {
              setValue('driver_license_expiry_date', e.target.value);
            }}
            placeholder="Enter Driver's License Expiration Date"
          />
        </div>

        {/* Other ID 1 */}
        <div>
          <label className="block text-sm font-medium text-gray-700">Other ID 1</label>
          <input
            type="text"
            {...register('order_id1')}
            className={inputClassName}
            placeholder="Enter Other ID 1"
          />
        </div>

        {/* Other ID 1 Expiration */}
        <div>
          <label className="block text-sm font-medium text-gray-700">Other ID 1 Expiration Date</label>
          <input
            type="text"
            {...register('order_id1_expiry_date')}
            className={`${inputClassName} datepicker`}
            onInput={(e) => {
              setValue('order_id1_expiry_date', e.target.value);
            }}
            placeholder="Enter Other ID 1 Expiration Date"
          />
        </div>

        {/* Other ID 2 */}
        <div>
          <label className="block text-sm font-medium text-gray-700">Other ID 2</label>
          <input
            type="text"
            {...register('order_id2')}
            className={inputClassName}
            placeholder="Enter Other ID 2"
          />
        </div>

        {/* Other ID 2 Expiration */}
        <div>
          <label className="block text-sm font-medium text-gray-700">Other ID 2 Expiration Date</label>
          <input
            type="text"
            {...register('order_id2_expiry_date')}
            className={`${inputClassName} datepicker`}
            onInput={(e) => {
              setValue('order_id2_expiry_date', e.target.value);
            }}
            placeholder="Enter Other ID 2 Expiration Date"
          />
        </div>

        {/* Other ID 3 */}
        <div>
          <label className="block text-sm font-medium text-gray-700">Other ID 3</label>
          <input
            type="text"
            {...register('order_id3')}
            className={inputClassName}
            placeholder="Enter Other ID 3"
          />
        </div>

        {/* Other ID 3 Expiration */}
        <div>
          <label className="block text-sm font-medium text-gray-700">Other ID 3 Expiration Date</label>
          <input
            type="text"
            {...register('order_id3_expiry_date')}
            className={`${inputClassName} datepicker`}
            onInput={(e) => {
              setValue('order_id3_expiry_date', e.target.value);
            }}
            placeholder="Enter Other ID 3 Expiration Date"
          />
        </div>

        {/* Short Bio */}
        <div className="sm:col-span-2">
          <label className="block text-sm font-medium text-gray-700">Short Bio</label>
          <textarea
            {...register('short_bio')}
            rows="3"
            className={inputClassName}
            placeholder="Enter Short Bio"
          />
        </div>
      </div>

      {/* Profile Picture */}
      <div className="sm:col-span-3">
        <label className="block text-sm font-medium text-gray-700">Profile Picture</label>
        <div className="mt-1 flex items-center space-x-4">
          <input
            type="file"
            accept="image/*"
            onChange={handleProfilePictureChange}
            className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
          />
          
          {(watch('image') || image) && (
           
            <div className="relative">
              
              <img
                src={image || watch('image')}
                alt="Profile"
                className="h-20 w-20 rounded-full object-cover"
              />
              <button
                type="button"
                onClick={() => handleDeleteImage()}
                className="absolute -top-2 -right-2 p-1 bg-red-500 rounded-full text-white hover:bg-red-600"
              >
                <TrashIcon className="h-4 w-4" />
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PersonalTab; 